export default __webpack_public_path__ + "static/media/part-two-bell-mobile.d03ea0bc.svg";